import api from "./api";
import { Cliente } from "../types/cliente";

type AuthenticateResponseData = {
  token: string;
  cliente: Cliente;
};

async function authenticate(
  cpf: string,
  password: string
): Promise<AuthenticateResponseData> {
  return await api
    .post<AuthenticateResponseData>("/api/v2/app/auth", { cpf, password })
    .then((response) => response.data);
}

const authApi = {
  authenticate,
};

export default authApi;
